import { api } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'

export const appsApi = api.enhanceEndpoints({
  endpoints: {
    getApiV1GroupsByGroupIdChannels: {
      providesTags: ['Group_Channels'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    postApiV1Apps: {
      invalidatesTags: ['Admin_Apps', 'Secure'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    getApiV1GroupsByGroupIdApps: {
      providesTags: (_result, _error, arg) => [
        { type: 'Group_Apps', id: arg.groupId },
      ],
      keepUnusedDataFor: 300,
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    getApiV1AppsUser: {
      providesTags: ['User_Apps', 'Secure'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    putApiV1AppsUserByAppId: {
      invalidatesTags: ['User_Apps'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    putApiV1GroupsByGroupIdAppsAndAppId: {
      invalidatesTags: ['User_Apps'],
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    getApiV1Apps: {
      providesTags: ['User_Apps', 'Secure'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    deleteApiV1GroupsByGroupIdAppsAndAppId: {
      invalidatesTags: ['Group_Apps'],
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    deleteApiV1AppsUserByAppId: {
      invalidatesTags: ['User_Apps'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    deleteApiV1AppsByAppId: {
      invalidatesTags: ['Admin_Apps', 'Secure'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    getApiV1AppsInstalled: {
      providesTags: ['Admin_Apps', 'Secure'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
  },
})

export const {
  useLazyGetApiV1GroupsByGroupIdChannelsQuery,
  usePutApiV1GroupsByGroupIdAppsAndAppIdMutation,
  useGetApiV1GroupsByGroupIdAppsQuery,
  useLazyGetApiV1GroupsByGroupIdAppsQuery,
  useDeleteApiV1AppsUserByAppIdMutation,
  usePutApiV1AppsUserByAppIdMutation,
  useGetApiV1AppsQuery,
  useGetApiV1AppsUserQuery,
  useGetApiV1AppsInstalledQuery,
  usePostApiV1AppsMutation,
  useDeleteApiV1AppsByAppIdMutation,
  useLazyGetApiV1AppsUserQuery,
  useLazyGetApiV1AppsQuery,
} = appsApi
